import { isNumber } from '@agilepoint/utils-common';
import React, { createElement, ReactElement, useCallback, useEffect, useRef, useState } from 'react';
import { toggleHeader } from 'roosterjs-editor-api';
import styled from 'styled-components';
import { useFormatState, useToolbarActionContext } from '../context';
import { CommandButton } from './command-button';
import { IEditorToolbarActionBaseProps } from './types';
import { Callout } from '../../../callout';
import { Typography } from '../../../typography';
import { IItemRenderProps, ListView } from '../../../listview';
import { selectThemeSemantics } from '../../../../styling';

const StyledListView = styled(ListView)`
    height: 230px;
    width: 170px;
    border: none;
    display: block;
    margin-top: ${selectThemeSemantics(({ gap }) => gap.s)};

    .ap-listView-itemContentWrapper {
        border: none;
    }
`;

function ContentHolder(props: IItemRenderProps) {
    const { adjustDimensions, renderDefault } = props;
    useEffect(() => adjustDimensions(), [adjustDimensions]);
    return renderDefault() as ReactElement;
}

function renderItem(info: IItemRenderProps) {
    return createElement(ContentHolder, info);
}

const Wrapper = styled.div`
    padding: ${selectThemeSemantics(({ gap }) => `${gap.m} ${gap.l}`)};
`;

const OPTIONS = [0, 1, 2, 3, 4, 5, 6];

function renderContent(item: number) {
    if (item === 0) {
        return <Wrapper>None</Wrapper>;
    }
    const Heading = (Typography as any)[`H${item}`];
    if (!Heading) {
        return <Wrapper>{`Invalid Header H${item}`}</Wrapper>;
    }
    return <Wrapper><Heading>Heading {item}</Heading></Wrapper>;
}

export function HeadingAction(props: IEditorToolbarActionBaseProps) {
    const itemRef = useRef<HTMLSpanElement>(null);
    const [isCalloutHidden, setCalloutHiddenStatus] = useState(true);
    const { editor } = useToolbarActionContext();
    const { headerLevel } = useFormatState();

    const showCallout = useCallback(() => {
        setCalloutHiddenStatus(false);
    }, []);

    const hideCallout = useCallback(() => {
        setCalloutHiddenStatus(true);
    }, []);

    const _onSelectionChange = useCallback(([selectedItem]: React.Key[]) => {
        toggleHeader(editor, Number(selectedItem));
        hideCallout();
    }, [editor, hideCallout]);

    return (
        <>
            <CommandButton {...props} tooltip="Heading" iconName="ap-heading.rte" iconSize="14" elementRef={itemRef} onClick={showCallout} />
            <Callout offset={-5} hidden={isCalloutHidden} isBeakVisible targetRef={itemRef} onDismiss={hideCallout}>
                <StyledListView allowKeyboardNavigation items={OPTIONS} onRenderItemContent={renderContent}
                    orientation="vertical" selectable="single" onRenderItem={renderItem}
                    onChange={_onSelectionChange} selectedKeys={isNumber(headerLevel) ? [headerLevel] : []} />
            </Callout>
        </>
    );
}
